import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class LogoService {
    private currentLogoSubject: BehaviorSubject<string>;
    
    constructor() {
        this.currentLogoSubject = new BehaviorSubject<string>("");
    }

    public set Logo(logo: string) {
        this.currentLogoSubject.next(logo);
    }

    public get currentLogoValue(): string {
        return this.currentLogoSubject.value;
    }

    public get logoSubject(): Observable<string> {
        return this.currentLogoSubject.asObservable();
    }
}